import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { LocaleProvider } from "./context/LocaleContext";
import { BrowserRouter } from "react-router-dom";
// eslint-disable-next-line
import { SpeedInsights } from "@vercel/speed-insights/react"

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <LocaleProvider>
        <App />
        <SpeedInsights />
      </LocaleProvider>
    </BrowserRouter>
  </React.StrictMode>
);
